<template>
  <div class="backlogDoneList">
    <BasePage mode="list">
      <div slot="toolBar">
        <!-- <el-row>
          <div style="float: right">
            <OfSearch
              @search="search"
              style="float: left; padding-right: 5%"
              :placeholder="placeholder"
            ></OfSearch>
            <el-button type="danger" @click="loadData">查询</el-button>
          </div>
        </el-row> -->
        <div class="searchbar">
          <div class="search-item">
            <div class="item-label">审核类型：</div>
            <div class="item-select">
              <el-select v-model="searchModel.procId" placeholder="请选择">
                <el-option value="">--请选择--</el-option>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="searchKey-item">
            <div class="item-label">关键字：</div>
            <div class="item-select">
              <el-input
                v-model="searchModel.searchKey"
                placeholder="请输入审核标题 "
              ></el-input>
            </div>
          </div>
          <div class="btn-item">
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="loadData"
              >查询</el-button
            >
          </div>
        </div>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="backlogModel"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="BusinessTitle"
            label="审核标题"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="ProcTitle"
            label="审核类型"
            align="center"
            width="150"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Creator"
            label="发起人"
            width="140"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="CurrentStepName"
            label="当前审批节点"
            align="center"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="PasserName"
            label="上一步发送人"
            width="140"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="StartTime"
            label="申请时间"
            align="center"
            width="140"
          >
            <template slot-scope="scope">
              {{ (scope.row.StartTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Status"
            label="状态"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ formatterStatus(scope.row.Status) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                type="text"
                size="mini"
                @click="innerAudit(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="searchModel.pageSize"
            :currentPage="searchModel.currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <DonationStemcell
      v-if="showDonationStemcell"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    >
    </DonationStemcell>
    <Donationorgan
      v-if="showDonationorgan"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    >
    </Donationorgan>
    <Groupmember
      v-if="showGroupmember"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></Groupmember>
    <Personalmember
      v-if="showPersonalmember"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></Personalmember>
    <Donationmaterials
      v-if="showDonationmaterials"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></Donationmaterials>
    <LifeGuard
      v-if="showLifeGuard"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></LifeGuard>
    <LifeGuardApply
      v-if="showLifeGuardApply"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></LifeGuardApply>
    <Lecture
      v-if="showLecture"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></Lecture>
    <Publicwelfare
      v-if="showPublicwelfare"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></Publicwelfare>
    <News
      v-if="showNews"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></News>
    <BigSickApply
      v-if="showBigSickApply"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></BigSickApply>
    <SeekHelpApply
      v-if="showSeekHelpApply"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></SeekHelpApply>
    <Implementproject
      v-if="showImplementproject"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></Implementproject>
    <VolunteerApply
      v-if="showVolunteerApply"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></VolunteerApply>
    <LifeGuardApplyPay
      v-if="showLifeGuardApplyPay"
      @auditCallBack="auditCallBack"
      :backlogModel="formData"
      :isHide="isHide"
    ></LifeGuardApplyPay>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page"
import OfPagination from "@/components/controls/of_pagination/of_pagination"
import DonationStemcell from "@/modules/zjrc/pages/workbench/backlog/donationstemcell/audit"
import Donationorgan from "@/modules/zjrc/pages/workbench/backlog/donationorgan/audit"
import Personalmember from "@/modules/zjrc/pages/workbench/backlog/personalmember/audit"
import Groupmember from "@/modules/zjrc/pages/workbench/backlog/groupmember/audit"
import Donationmaterials from "@/modules/zjrc/pages/workbench/backlog/donationmaterials/audit"
import LifeGuard from "@/modules/zjrc/pages/workbench/backlog/lifeGuard/audit"
import LifeGuardApply from "@/modules/zjrc/pages/workbench/backlog/lifeGuardapply/audit"
import Lecture from "@/modules/zjrc/pages/workbench/backlog/lecture/audit"
import Publicwelfare from "@/modules/zjrc/pages/workbench/backlog/publicwelfare/audit"
import News from "@/modules/zjrc/pages/workbench/backlog/news/audit"
import BigSickApply from "@/modules/zjrc/pages/workbench/backlog/bigSickApply/audit"
import SeekHelpApply from "@/modules/zjrc/pages/workbench/backlog/seekHelpApply/audit"
import Implementproject from "@/modules/zjrc/pages/workbench/backlog/implementproject/audit"
import VolunteerApply from "@/modules/zjrc/pages/workbench/backlog/volunteerApply/audit"
import LifeGuardApplyPay from "@/modules/zjrc/pages/workbench/backlog/lifeGuardapply/auditTwo"
import { mapGetters } from "vuex"
import api from "@/modules/zjrc/api"

export default {
  name: "list",
  data() {
    return {
      headerRow: "headerRow",
      placeholder: "请输入审核标题 / 审核类型",
      total: 0,
      searchModel: {
        searchKey: "",
        currentPage: 1,
        pageSize: 15,
        IsCompleted: false,
        procId: "",
      },
      isloading: false,
      isHide: true, //隐藏驳回、通过按钮
      backlogModel: [], //待办数组
      showDonationStemcell: false, //造血干细胞捐献
      showDonationorgan: false, //器官捐献
      showGroupmember: false, //团体会员
      showPersonalmember: false, //个人会员
      showDonationmaterials: false, //物资捐赠
      showLifeGuard: false, //救护培训活动
      showLifeGuardApply: false, //救护员培训
      showLecture: false, //收费讲座
      showPublicwelfare: false, //公益项目
      showNews: false, //新闻
      showBigSickApply: false, //大病申请
      showSeekHelpApply: false, //其他申请
      showImplementproject: false, //实施项目
      showVolunteerApply: false,
      showLifeGuardApplyPay: false,
      formData: {}, //待办对象
      options: [],
    }
  },
  components: {
    BasePage,
    OfPagination,
    DonationStemcell,
    Donationorgan,
    Groupmember,
    Personalmember,
    Donationmaterials,
    LifeGuard,
    LifeGuardApply,
    Lecture,
    Publicwelfare,
    News,
    BigSickApply,
    SeekHelpApply,
    Implementproject,
    VolunteerApply,
    LifeGuardApplyPay,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    let that = this
    that.loadData()
    that.getOption()
  },
  methods: {
    formatterStatus(val) {
      switch (val) {
        case 0:
          return "撤回"
        case 1:
          return "审批中"
        case 2:
          return "通过"
        case 3:
          return "通过"
        case 4:
          return "驳回"
        default:
          return "-"
      } 
    },
    getOption() {
      let that = this
      api.QueryApprovalProcessOption().then((res) => {
        if (res.data.Code === 0) {
          let option = res.data.Data
          option.forEach((item) => {
            that.options.push({ label: item.ProcName, value: item.Id })
          })
        }
      })
    },
    loadData() {
      let that = this
      let params = {
        SearchKey: that.searchModel.searchKey,
        PageIndex: that.searchModel.currentPage,
        PageSize: that.searchModel.pageSize,
        UserId: that.GetCurrentUserInfo.Id,
        IsCompleted: true,
        ProcId: that.searchModel.procId,
      }
      that.isloading = true
      api.QueryBacklog(params).then((res) => {
        if (res.data.Code == 0) {
          that.backlogModel = res.data.Data.rows
          that.total = res.data.Data.total
        }
        that.isloading = false
      })
    },
    //搜索框
    search(searchKey) {
      let that = this
      that.searchModel.searchKey = searchKey
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight
      var tableMaxHeight = 0
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 300
      }
      return tableMaxHeight
    },
    //审核
    innerAudit(rowData) {
      let that = this
      that.formData = rowData
      switch (rowData.ProcId) {
        case "daa6f8f1-429a-4b84-8a96-aca7011ec30d":
          that.showDonationStemcell = true
          break
        case "6c8eaaa1-66f9-4419-9da2-aca7011efddf":
          that.showDonationorgan = true
          break
        case "0482bc79-0e6f-4a03-a99b-ac9901176c1f":
          that.showGroupmember = true
          break
        case "ec01e665-2619-45eb-ae1c-ac9901175bcb":
          that.showPersonalmember = true
          break
        case "12e11a6b-d85a-4ffb-98ce-ac9901174a2d":
          that.showDonationmaterials = true
          break
        case "ecff4142-6d1b-4efb-9da1-ac9901171884":
          that.showLifeGuard = true
          break
        case "9ad3b87e-8bac-4ffd-9992-ac9901170770":
          that.showLifeGuardApply = true
          break
        case "20293636-c4a5-4710-8cf2-ac990116f341":
          that.showLecture = true
          break
        case "2882cd13-deab-4969-a36a-ac990115c63e":
          that.showPublicwelfare = true
          break
        case "651299c2-8378-41c8-8bc4-aca7011f3e7b":
          that.showBigSickApply = true
          break
        case "b46d4022-d269-44cf-906b-aca7011f7734":
          that.showSeekHelpApply = true
          break
        case "fb37b351-f908-48f3-a382-acb800f032eb":
          that.showImplementproject = true
          break
        case "ebb29566-eed1-4a15-8cb2-ad710083de5b":
          that.showVolunteerApply = true
          break
        case "33980d38-92d9-4629-b24f-ad75007fa09f":
          that.showLifeGuardApplyPay = true
          break
        default:
          that.showNews = true
      }
    },
    //审核回调
    auditCallBack(data) {
      let that = this
      that.showDonationStemcell = false
      that.showDonationorgan = false
      that.showGroupmember = false
      that.showPersonalmember = false
      that.showDonationmaterials = false
      that.showLifeGuard = false
      that.showLifeGuardApply = false
      that.showLecture = false
      that.showPublicwelfare = false
      that.showNews = false
      that.showBigSickApply = false
      that.showSeekHelpApply = false
      that.showImplementproject = false
      that.showVolunteerApply = false
      that.showLifeGuardApplyPay = false
      if (data) {
        that.loadData()
      }
    },
    //页数切换
    handleSizeChange(val) {
      let that = this
      that.searchModel.currentPage = 1
      that.searchModel.pageSize = val
      that.loadData()
    },
    //页码切换
    handleCurrentChange(val) {
      let that = this
      if (that.total > that.searchModel.pageSize) {
        that.searchModel.currentPage = val
        that.loadData()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.backlogDoneList {
  .searchbar {
    display: flex;
    .search-item {
      display: flex;
      margin-right: 15px;
    }
    .searchKey-item {
      margin-right: 15px;
      display: flex;
    }
  }
}
</style>
